import { EventBus } from "@/services/eventBus";
import $amplitude from "@/services/amplitude";
import router from "@/router";
import { AmplitudeEvents } from "@/events/AmplitudeEvents";

Object.values(AmplitudeEvents).forEach((e) => {
  EventBus.$on(e, (options: Record<string, unknown> = {}) => {
    if (!options.location && router.currentRoute) {
      options.location = router.currentRoute.name;
    }

    $amplitude.logEvent(e, options);
  });
});
